import { render, staticRenderFns } from "./music-player.vue?vue&type=template&id=4e62b35a&scoped=true&"
import script from "./music-player.vue?vue&type=script&lang=js&"
export * from "./music-player.vue?vue&type=script&lang=js&"
import style0 from "./music-player.vue?vue&type=style&index=0&id=4e62b35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e62b35a",
  null
  
)

export default component.exports